/**
 * Meter_Service.ts
 * Per-plan usage/quota (sk-catalog-api /api/v1/meter/usage).
 * Powers the quota bars and at-cap gating in the UI.
 */

import axiosInstance from '../../api/axiosInstance';
import { Catalog_Meter_Usage_Url } from '../../api/endpoints';
import type { MeterUsageResponse } from '../../schemas/catalog/meter';

/* ─────────────────────────────────────────
   Usage — GET /api/v1/meter/usage
   Never rejects on "metering off / meter down": the backend already returns a
   calm { enabled, degraded, metrics } shape. On a transport failure we degrade
   to an empty result so the UI never shows an error wall for quota.
───────────────────────────────────────── */

const EMPTY_USAGE: MeterUsageResponse = { enabled: false, degraded: false, metrics: [] };

export const getMeterUsage = async (): Promise<MeterUsageResponse> => {
  try {
    const { data } = await axiosInstance.get<MeterUsageResponse>(Catalog_Meter_Usage_Url);
    return data;
  } catch {
    // Transport/network error — treat as degraded rather than surfacing an error.
    return { ...EMPTY_USAGE, degraded: true };
  }
};
